import React from 'react';

import { ItemsPerSubUnit } from '@modules/advancement/unitAdvancement/types';
import { Tooltip } from '@modules/shared';

interface PendingItemsCustomRow {
  children?: React.ReactNode;
  shouldDisableRecord?: (record: ItemsPerSubUnit) => void;
}

const PendingItemsCustomRow: React.FC<PendingItemsCustomRow> = props => {
  const { children, shouldDisableRecord } = props;

  // check if children is undefined or null or not an array
  // check if first array exist and has props
  if (
    !children ||
    !Array.isArray(children) ||
    !children[0] ||
    !('props' in children[0])
  ) {
    return <tr {...props}>{children}</tr>;
  }

  const { record } = children[0].props;
  const shouldDisable = shouldDisableRecord && shouldDisableRecord(record);

  return !shouldDisable ? (
    <tr {...props} />
  ) : (
    <Tooltip
      title={`Position does not grant permission to award.`}
      placement="top"
    >
      <tr {...props} />
    </Tooltip>
  );
};

export default PendingItemsCustomRow;
